import Route from '@ember/routing/route';

export default class PagesRoute extends Route {}
